import { useEffect, useState } from "react"
import * as React from "react"
import { PaginationType } from "@/types"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useReactToPrint } from "react-to-print"

import { EditBookType } from "@/types/book"
import { canViewThisPage } from "@/lib/api/auth"
import { getBooksPerZoneTable } from "@/lib/api/billing"
import { Button } from "@/components/ui/button"
import { DataTable } from "@/components/data-table"
import { Header } from "@/components/header"
import { Icons } from "@/components/icons"
import { booksColumns } from "@/components/table/columns/books-columns"
import { ExportOperationModal } from "@/components/table/operations/export-operations"

import { AddBooksPage } from "./add"

export const Route = createFileRoute("/_home/zone-settings/books-zone/")({
  beforeLoad: () => {
    if (canViewThisPage("himo_billing.view_books")) {
      return
    }

    return redirect({ to: "/access-denied" })
  },
  component: BooksPage,
})

function BooksPage() {
  const [zones, setZones] = useState<number[]>([])
  const [defaultPage, setDefaultPage] = useState<number>(10)
  const [page, setPage] = useState<number>(1)
  const [search, setSearch] = useState<string>("")
  const [showExportModal, setShowExportModal] = React.useState<boolean>(false)

  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null)
  const [prevPageUrl, setPrevPageUrl] = useState<string | null>(null)

  const {
    data: booksZoneDetails,
    isError,
    isLoading,
  } = useQuery<PaginationType<EditBookType>>({
    queryKey: ["books-per-zone", defaultPage, page, search, zones],
    queryFn: () => getBooksPerZoneTable(defaultPage, page, search, zones),
  })

  useEffect(() => {
    if (booksZoneDetails) {
      setNextPageUrl(booksZoneDetails.next)
      setPrevPageUrl(booksZoneDetails.previous)
    }
  }, [booksZoneDetails])

  const contentRef = React.useRef<HTMLDivElement>(null)
  const reactToPrintFn = useReactToPrint({ contentRef })

  return (
    <main className="space-y-4 p-4">
      <Header>Books Zone</Header>
      <div ref={contentRef} className="print:p-2">
        <DataTable
          columns={booksColumns}
          data={booksZoneDetails?.results ?? []}
          search={{
            //field: "name",
            label: "name",
            value: search,
            onChange: setSearch,
          }}
          isLoading={isLoading}
          isError={isError}
          defaultPage={defaultPage}
          setDefaultPage={setDefaultPage}
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          page={page}
          setPage={setPage}
          totalCount={booksZoneDetails?.count}
          //tableTitle="Books Zone"
          zones={zones}
          setZones={setZones}
        >
          <div className="flex w-full justify-end">
            <AddBooksPage />
            <Button
              onClick={(e) => reactToPrintFn()}
              variant="outline"
              className="mx-1 bg-primary text-white hover:bg-primary hover:text-white print:hidden"
            >
              <Icons.download className="mr-2 h-4 w-4" />
              Print Book Zone
            </Button>
            <ExportOperationModal
              tableData={booksZoneDetails?.results ?? [{}]}
              fileName="Book zone"
              showExportModal={showExportModal}
              setShowExportModal={setShowExportModal}
            />
          </div>
        </DataTable>
      </div>
    </main>
  )
}
